module.exports = __webpack_public_path__ + "assets/img/logo.6d035c14.png";